var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyMetricScore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Metric_Score",
    "data-name": "My Metric Score",
    transform: "translate(-698 -458)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2225",
    "data-name": "Rectangle 2225",
    width: 64,
    height: 64,
    transform: "translate(698 458)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user_2_",
    "data-name": "user (2)",
    transform: "translate(701.839 424.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1779",
    "data-name": "Group 1779",
    transform: "translate(0 42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1778",
    "data-name": "Group 1778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M28.075,65.5A12.244,12.244,0,1,0,16,65.5C6.778,67.918,0,75.717,0,84.961v3.007a1.224,1.224,0,1,0,2.449,0V84.961c0-9.817,8.789-17.808,19.59-17.808s19.59,7.99,19.59,17.808v3.007a1.224,1.224,0,1,0,2.449,0V84.961C44.078,75.717,37.3,67.915,28.075,65.5ZM12.244,54.91a9.8,9.8,0,1,1,9.8,9.8A9.8,9.8,0,0,1,12.244,54.91Z",
    transform: "translate(0 -42.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M337.274,103.3a9.786,9.786,0,0,0-5.382-17.964,1.224,1.224,0,1,0,0,2.449,7.346,7.346,0,0,1,0,14.693,1.224,1.224,0,1,0,0,2.449c8.1,0,14.693,6.09,14.693,13.578v2.339a1.224,1.224,0,1,0,2.449,0V118.5C349.033,111.426,344.1,105.414,337.274,103.3Z",
    transform: "translate(-292.711 -80.436)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMetricScore);
export default __webpack_public_path__ + "static/media/my-metric-score.2d9c53600203bb46632a0c7d7ca6d6eb.svg";
export { ForwardRef as ReactComponent };